import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {useHistory, useLocation} from "react-router-dom";
import styled from "styled-components";
import { BrowserView, MobileView, isTablet } from 'react-device-detect';
import CancelIcon from "../../images/activity-sitcom/cancel-icon2.png";
import HelpIcon from "../../images/activity-sitcom/help-icon2.png";

//캐릭터
import grandmother from "../../images/word-play/hht2-image/01_grandmother.png";
import aunt from "../../images/word-play/hht2-image/02_aunt.png";
import sister from "../../images/word-play/hht2-image/03_sister.png";
import mother from "../../images/word-play/hht2-image/04_mother.png";
import grandfather from "../../images/word-play/hht2-image/05_grandfather.png";
import father from "../../images/word-play/hht2-image/06_father.png";
import uncle from "../../images/word-play/hht2-image/07_uncle.png";
import cousin from "../../images/word-play/hht2-image/08_cousin.png";
import attic from "../../images/word-play/hht2-image/09_attic.png";
import garage from "../../images/word-play/hht2-image/10_garage.png";
import balcony from "../../images/word-play/hht2-image/11_balcony.png";
import bathroom from "../../images/word-play/hht2-image/12_bathroom.png";
import garden from "../../images/word-play/hht2-image/13_garden.png";
import livingroom from "../../images/word-play/hht2-image/14_living room.png";
import kitchen from "../../images/word-play/hht2-image/15_kitchen.png";
import bedroom from "../../images/word-play/hht2-image/16_bedroom.png";


import Sound from "../../images/word-play/word-sound.png";
import Blank from "../../images/word-play/polariod_blank.png";

import GuideAni from "../../images/direction/quide-fingure.png";


/*css*/
import "../../css/wordplay.css";


const Index = () => {
  return (
    <>
    {/*가이드애니*/}
    <div className="guide-ani">
        <img src={GuideAni} alt="" />
    </div>
    {/*가이드애니*/}
    <div className="word-play2">
        <div>
            <div className="contents d-flex flex-column justify-content-between">
                <div className="route_bar d-flex align-items-center justify-content-between">
                    <div className="right_icon">
                        <img className="help_icon_img" src={HelpIcon} alt="" />
                        <img className="cancel_icon_img" src={CancelIcon} alt="" />
                    </div>
                </div>
            </div>
        </div>
        <div className="classification">
            <p className="titleW">Drag the pictures to the correct place.</p>
            <div className="board">
                <div className="left">
                    <p className="titleP">Family</p>
                    <div className="photo-zone">
                        <div className="photo-zone-inner">
                            <div className="photo" style={{'transform':'rotate(7deg)'}}>
                                <div className="imgarea">
                                    <img src={grandfather} alt="" />
                                </div>
                                <p>grandfather</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(0deg)'}}>
                                <div className="imgarea">
                                    <img src={sister} alt="" />
                                </div>
                                <p>sister</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(7deg)'}}>
                                <div className="imgarea">
                                    <img src={grandmother} alt="" />
                                </div>
                                <p>grandmother</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(-11deg)'}}>
                                <div className="imgarea">
                                    <img src={uncle} alt="" />
                                </div>
                                <p>uncle</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(-4deg)'}}>
                                <div className="imgarea">
                                    <img src={mother} alt="" />
                                </div>
                                <p>mother</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(0deg)'}}>
                                <div className="imgarea">
                                    <img src={aunt} alt="" />
                                </div>
                                <p>aunt</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(1deg)'}}>
                                <div className="imgarea">
                                    <img src={cousin} alt="" />
                                </div>
                                <p>cousin</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(4deg)'}}>
                                <div className="imgarea">
                                    <img src={father} alt="" />
                                </div>
                                <p>father</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="center">
                    <div className="photos">
                        <div className="photo" style={{'transform':'rotate(3deg)'}}></div>
                        <div className="photo" style={{'transform':'rotate(-5deg)'}}>                            
                            <div className="imgarea">
                                    <img src={balcony} alt="" />
                                </div>
                                <p>balcony</p>
                            </div>
                        <div className="photo">
                            <div className="imgarea">
                                <img src={grandfather} alt="" />
                            </div>
                            <p>grandfather</p>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <p className="titleP">House</p>
                    <div className="photo-zone">
                        <div className="photo-zone-inner">
                            <div className="photo" style={{'transform':'rotate(9deg)'}}>
                                <div className="imgarea">
                                    <img src={attic} alt="" />
                                </div>
                                <p>attic</p>
                            </div>
                            {/* <div className="photo" style={{'transform':'rotate(-1deg)'}}>
                                <div className="imgarea">
                                    <img src={garage} alt="" />
                                </div>
                                <p>garage</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(3deg)'}}>
                                <div className="imgarea">
                                    <img src={balcony} alt="" />
                                </div>
                                <p>balcony</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(-9deg)'}}>
                                <div className="imgarea">
                                    <img src={bathroom} alt="" />
                                </div>
                                <p>bathroom</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(4deg)'}}>
                                <div className="imgarea">
                                    <img src={garden} alt="" />
                                </div>
                                <p>garden</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(-1deg)'}}>
                                <div className="imgarea">
                                    <img src={livingroom} alt="" />
                                </div>
                                <p>livingroom</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(0deg)'}}>
                                <div className="imgarea">
                                    <img src={kitchen} alt="" />
                                </div>
                                <p>kitchen</p>
                            </div>
                            <div className="photo" style={{'transform':'rotate(-4deg)'}}>
                                <div className="imgarea">
                                    <img src={bedroom} alt="" />
                                </div>
                                <p>bedroom</p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
    </>
  );
};

export default Index;
